import axios from 'axios';

let languageServiceUrl = process.env.REACT_APP_LANGUAGE_SERVICE_URL;

const getAllLanguage = async () => {
    let apiURL = `${languageServiceUrl}/languageService/language`;

    return new Promise(function (resolve, reject) {
        axios.get(apiURL)
            .then((response) => {
                resolve(response.data.dataObject);
            })
            .catch(error => {
                reject(error.response.data);
            });
    });
}

const translateToTargetLanguage = async (formData) => {
    let apiURL = `${languageServiceUrl}/languageService/translateToTargetLanguage`;
    let queryParam = {
        params: {
            words: formData
        }
    }

    return new Promise(function (resolve, reject) {
        axios.get(apiURL, queryParam)
            .then((response) => {
                resolve(response.data.dataObject);
            })
            .catch(error => {
                reject(error.response.data);
            });
    });
}

const getMessages = async (messageId) => {
    let languageCode = localStorage.getItem("languageCode");
    let apiURL = `${languageServiceUrl}/languageService/responseEngine`;
    let queryParam = {
        params: {
            messageId: messageId,
            languageCode: languageCode
        }
    }

    return new Promise(function (resolve, reject) {
        axios.get(apiURL, queryParam)
            .then((response) => {
                resolve(response.data.message);
            })
            .catch(error => {
                reject(error.response.data);
            });
    });
}

const getValueMessages = async (messageId, values) => {
    let languageCode = localStorage.getItem("languageCode");
    let apiURL = `${languageServiceUrl}/languageService/responseEngine`;
    let queryParam = {
        params: {
            messageId: messageId,
            languageCode: languageCode,
            values: values
        }
    }

    return new Promise(function (resolve, reject) {
        axios.get(apiURL, queryParam)
            .then((response) => {
                console.log('data........', response)
                resolve(response.data.message);
            })
            .catch(error => {
                reject(error.response.data);
            });
    });
}

const getFieldAndValueMessages = async (messageId, fields, values) => {
    let languageCode = localStorage.getItem("languageCode");
    let apiURL = `${languageServiceUrl}/languageService/responseEngine`;
    let queryParam = {
        params: {
            messageId: messageId,
            languageCode: languageCode,
            fields: fields,
            values: values
        }
    }

    return new Promise(function (resolve, reject) {
        axios.get(apiURL, queryParam)
            .then((response) => {
                console.log('data........', response)
                resolve(response.data.message);
            })
            .catch(error => {
                reject(error.response.data);
            });
    });
}

const getFieldMessages = async (messageId, fields) => {

    let languageCode = localStorage.getItem("languageCode");
    let apiURL = `${languageServiceUrl}/languageService/responseEngine`;
    let queryParam = {
        params: {
            messageId: messageId,
            languageCode: languageCode,
            fields: fields ? JSON.stringify(fields) : ''
        }
    }

    return new Promise(function (resolve, reject) {
        axios.get(apiURL, queryParam)
            .then((response) => {
                resolve(response.data.message);
            })
            .catch(error => {
                reject(error.response.data);
            });
    });
}

export {
    getAllLanguage,
    translateToTargetLanguage,
    getMessages,
    getValueMessages,
    getFieldMessages,
    getFieldAndValueMessages
}